import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generaltransaction-menu',
  templateUrl: './generaltransaction-menu.component.html',
  styleUrls: ['./generaltransaction-menu.component.css']
})
export class GeneraltransactionMenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='General Transaction')
        this.pageList=this.menuList[i].KHB_PagesList;
        console.log('PageList');
        console.log(this.pageList);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/general-transaction/generaltransaction-menu/generaltransaction-menu.component.ts